<script>
import {mapActions, mapGetters, mapState} from "vuex";
import GMOPaymentCardDialog from "./GMOPaymentCardDialog.vue";

export default {
  name: "GMOPaymentForm",
  components: {GMOPaymentCardDialog},
  props: {
    ticket: Object,
    paymentMethod: String,
    disabled: Boolean,
    order: Object
  },
  data() {
    return {
      mulPayFormElements: null,
      cardDialog: false,
    }
  },
  computed: {
    ...mapState('gmo', ['mulpay']),
    ...mapGetters('gmo', ['cardInputStyle', 'expiryInputStyle', 'cvcInputStyle',])
  },
  async mounted() {
    if (this.order) return;
    await this.initPayment();
  },
  methods: {
    ...mapActions('gmo', ['initPayment', 'submitWithCredit', 'submitWithCVS', 'getLink', 'submitWithCreditLink']),
    async submit() {
      console.log('submit')
      if (this.order) {
        await this.getLink();
        return;
      }
      try {
        switch (this.paymentMethod) {
          case 'card':
            // this.cardDialog = true
            await this.submitWithCreditLink(this.ticket);
            return;
          case 'webcvs':
            await this.submitWithCVS(this.ticket);
        }
      } catch (err) {
        console.error(err);
        alert("送信に失敗しました。しばらく経ってから再度お試しください。")
      }
    },
    async submitWithCreditFromDialog(arg) {
      console.log('submitWithCreditFromDialog', arg)
      await this.submitWithCredit({ticket: this.ticket, token: arg.token});
    }
  }
}
</script>

<template>
  <div>
    <!--    <GMOPaymentCardDialog v-model="cardDialog" :ticket="ticket" @submit="submitWithCreditFromDialog"></GMOPaymentCardDialog>-->

    <v-btn @click="submit" color="primary" rounded class="white--text buttonStyle" :disabled="disabled">
      <slot></slot>
    </v-btn>
  </div>
</template>

<style scoped>

</style>
